import renderInlineItalic from 'lib/utils/renderInlineItalic';
import { useRef } from 'react';
import Image from 'components/shared/image/image';
import classNames from 'classnames';
import RichText from 'components/shared/richtext';
import Button from 'components/shared/button';
import handleDrag from 'lib/utils/handleDrag';
import useIsMobile from 'hooks/utils/useIsMobile';
import styles from './gallerySlider.module.scss';

const GallerySlider = ({ data, locale }) => {
  const { title, titleFont, subtitle, gallery, align, anchorId } = data;
  const titleClass = classNames(
    styles.gallerySliderTitle,
    titleFont !== 'Acumin Pro' && styles.octave
  );
  const carouselRef = useRef(null);
  const isMobile = useIsMobile();

  const getAlign = () => {
    switch (align) {
      case 'left':
        return 'flex-start';
      case 'right':
        return 'flex-end';
      default:
        return 'center';
    }
  };

  const getTextAlign = () => {
    switch (align) {
      case 'left':
        return 'left';
      case 'right':
        return 'right';
      default:
        return 'center';
    }
  };

  const dragHandler = e => {
    if (isMobile) return;
    const { scrollLeft } = carouselRef.current;
    handleDrag(e, carouselRef, {
      leftSideCallback: (ev, delta) => {
        carouselRef.current.scrollLeft = scrollLeft - delta.x;
      },
      rightSideCallback: (ev, delta) => {
        carouselRef.current.scrollLeft = scrollLeft - delta.x;
      },
    });
  };

  return (
    <section
      id={anchorId}
      className={styles.gallerySliderSection}
      style={{ 'align-items': getAlign() }}
    >
      <span className={styles.titleAndTextWrapper} style={{ textAlign: getTextAlign() }}>
        {title && <h2 className={titleClass}>{renderInlineItalic(title)}</h2>}
        {subtitle && <h3 className={styles.gallerySliderSubtitle}>{subtitle}</h3>}
      </span>
      <div
        role="tablist"
        className={styles.carouselWrapper}
        ref={carouselRef}
        tabIndex={0}
        onPointerDown={e => dragHandler(e)}
      >
        <div className={classNames(styles.galleryContainer)}>
          {gallery.map(item => (
            <div className={styles.galleryItem}>
              <Image draggable={false} src={item.media.image} layout="responsive" loading="lazy" />
              <div className={styles.galleryItemWrapper}>
                {item.title && <div className={styles.galleryItemTitle}>{item.title}</div>}
                {item.text?.json && (
                  <div className={styles.galleryItemText}>
                    <RichText text={item.text?.json} />
                  </div>
                )}
                {item.button && (
                  <Button locale={locale} button={item.button} className={styles.galeryButton} />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySlider;
